'use client';

import { useSegmentTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { LandingPageExperimentViewedProps, TrackingFunction } from '../types';

export const useLandingPageExperimentTracking = (
  props: LandingPageExperimentViewedProps,
  autoTrack: boolean = false,
): TrackingFunction => {
  return useSegmentTrack(
    {
      eventName: ANALYTICS_EVENTS.LANDING_PAGE_EXPERIMENT_VIEWED,
      properties: props,
    },
    autoTrack,
  );
};
